export default {
    path : "land-carrier-recycled",
    name : "land-carrier-recycled",
    meta : {
        title : "载体回收站"
    },
    component: () => import('@/pages/land/recycledCarrier/Index'),
    redirect: {
        name : "land-carrier-recycled-whole"
    },
    children: [
        {
            path: 'all',
            name: 'land-carrier-recycled-whole',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'recent',
            name: 'land-carrier-recycled-recent',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'atme',
            name: 'land-carrier-recycled-atme',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'meat',
            name: 'land-carrier-recycled-meat',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'reply',
            name: 'land-carrier-recycled-reply',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'search',
            name: 'land-carrier-recycled-search',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/land/recycledcarrier/index.js